import { TEMPS_DMO_MIN } from "../content/textes";
import { fmtDuration, stationCost, travelTime } from "../model/run";
import { useApp } from "../state/store";

/** Temps entre repères (contre le dossier) et tableau des gares. */
export function Detail() {
  const route = useApp((s) => s.route)!;
  const result = useApp((s) => s.result)!;
  const scenario = useApp((s) => s.scenario);
  const stationName = useApp((s) => s.stationName);
  const select = useApp((s) => s.select);
  const selected = useApp((s) => s.selected);

  const lm = route.landmarks;
  const legs = lm.slice(0, -1).map((a, k) => {
    const b = lm[k + 1];
    const t = travelTime(result, a.idx, b.idx);
    return { a: a.name, b: b.name, t, dmo: TEMPS_DMO_MIN[`${a.name}→${b.name}`] };
  });
  const totalDmo = Object.values(TEMPS_DMO_MIN).reduce((s, v) => s + v, 0);

  return (
    <section className="detail">
      <h2>Entre les villes</h2>
      <table>
        <thead>
          <tr>
            <th scope="col">tronçon</th>
            <th scope="col">ce scénario</th>
            <th scope="col">
              <abbr title="temps annoncés au dossier du maître d'ouvrage, juin 2026">dossier</abbr>
            </th>
          </tr>
        </thead>
        <tbody>
          {legs.map((l) => (
            <tr key={l.a + l.b}>
              <td>
                {l.a} → {l.b}
              </td>
              <td>{fmtDuration(l.t)}</td>
              <td>{l.dmo !== undefined ? `~${l.dmo} min` : "—"}</td>
            </tr>
          ))}
          <tr className="total">
            <td>bout en bout</td>
            <td>{fmtDuration(result.T)}</td>
            <td>~{totalDmo} min</td>
          </tr>
        </tbody>
      </table>
      <p className="note">
        Le dossier annonce des temps plus longs que ce modèle : marges de régularité, arrêts plus longs en gare principale,
        limitations de vitesse que nous ne connaissons pas. Voir « Méthode ».
      </p>

      <h2>Les gares</h2>
      <table className="gares">
        <thead>
          <tr>
            <th scope="col">gare</th>
            <th scope="col">PK</th>
            <th scope="col">arrivée</th>
            <th scope="col">
              <abbr title="temps ajouté à tous les voyageurs qui traversent cette gare">coût</abbr>
            </th>
          </tr>
        </thead>
        <tbody>
          {result.stops.map((idx, k) => {
            const inter = k > 0 && k < result.stops.length - 1;
            return (
              <tr key={idx} className={idx === selected ? "sel" : ""} onClick={() => select(idx)}>
                <td>{stationName(idx)}</td>
                <td>{((idx * route.step_m) / 1000).toFixed(1)}</td>
                <td>{k === 0 ? "départ" : fmtDuration(result.arrivals[k])}</td>
                <td>{inter ? `+${Math.round(stationCost(route, scenario.stops, idx, scenario.settings))} s` : "—"}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </section>
  );
}
